import React from 'react'
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import { connect } from 'react-redux';
import * as siteMaster from '~/data/actions/siteActions';

import AddGroupView from '~/pages/cp/subscribers/groups/incGoAddGroup';
import ChangeGroupConfirm from './incChangeGroupConfirm';


@connect((store) => {
    return { user: store.user, permissionStore: store.permission, siteMaster: store.siteMaster }
})
export default class LboChangeGroup extends React.Component {
    constructor(props) {
        super(props);
        const appSettings = (props.appBinding && props.appBinding.appSettings) || {};
        const savedCompanyId = appSettings.companyId != null && appSettings.companyId !== ''
            ? Number(appSettings.companyId)
            : -1;
        this.state = {
            groupId: -1,
            groupData: [],
            isLoaded: false,
            marketingQuestions: [],
            companies: [],
            companyId: Number.isNaN(savedCompanyId) ? -1 : savedCompanyId,
            connectionError: '',
            marketingError: '',
            consentQuestionId: appSettings.consentQuestionId != null && appSettings.consentQuestionId !== ''
                ? String(appSettings.consentQuestionId)
                : 'all',
        };

        this.changeGroup = this.changeGroup.bind(this);
        this.changeCompany = this.changeCompany.bind(this);
        this.changeConsent = this.changeConsent.bind(this);
        this.addAGroup = this.addAGroup.bind(this);
        this.addedGroup = this.addedGroup.bind(this);
        this.getGroups = this.getGroups.bind(this);
        this.getCompanies = this.getCompanies.bind(this);
        this.getMarketingQuestions = this.getMarketingQuestions.bind(this);
        this.changeGroupConfirm = this.changeGroupConfirm.bind(this);
        this.changeTheGroup = this.changeTheGroup.bind(this);
    }

    componentDidMount() {
        this.getGroups();
        this.getCompanies();
        this.getMarketingQuestions();
    }

    getGroups() {
        axios.get("/group").then(_theGroups => {
            this.setState({ groupData: _theGroups.data.Groups, isLoaded: true })
        })
    }

    getCompanies() {
        axios.get('/application/littleboxoffice/site').then(_theSite => {
            const companies = (_theSite.data && _theSite.data.companies) || []
            const appSettings = (this.props.appBinding && this.props.appBinding.appSettings) || {}
            let companyId = this.state.companyId
            if (companyId == null || companyId === '' || companyId === -1) {
                const saved = appSettings.companyId != null && appSettings.companyId !== ''
                    ? Number(appSettings.companyId)
                    : companies[0]
                        ? Number(companies[0].id)
                        : -1
                companyId = Number.isNaN(saved) ? -1 : saved
            }
            this.setState({ companies, companyId, connectionError: '' })
        }).catch((err) => {
            const data = err && err.response && err.response.data
            const apiError = (typeof data.error === 'string' && data.error) || (typeof data.message === 'string' && data.message) || ''
            this.setState({
                companies: [],
                connectionError: apiError || 'Could not connect to Little Box Office. Check your API token and reconnect.',
            })
        })
    }

    getMarketingQuestions() {
        axios.get("/application/littleboxoffice/marketingQuestions").then(_theResp => {
            const fromApi = _theResp.data.consentQuestionId != null && _theResp.data.consentQuestionId !== ''
                ? String(_theResp.data.consentQuestionId)
                : 'all';
            this.setState({
                marketingQuestions: _theResp.data.questions || [],
                consentQuestionId: fromApi === 'all' ? (this.state.consentQuestionId || 'all') : fromApi,
                marketingError: (_theResp.data.meta && _theResp.data.meta.error) || '',
            })
        }).catch((err) => {
            const data = err && err.response && err.response.data
            const apiError = (typeof data.error === 'string' && data.error) || (typeof data.message === 'string' && data.message) || ''
            this.setState({
                marketingQuestions: [],
                marketingError: apiError,
            })
        })
    }

    changeGroup(event) {
        this.setState({ groupId: event.target.value })
    }

    changeCompany(event) {
        this.setState({ companyId: event.target.value })
    }

    changeConsent(event) {
        this.setState({ consentQuestionId: event.target.value })
    }

    addAGroup() {
        var drawerContent = <AddGroupView addedGroup={this.addedGroup} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, "right", drawerContent, true, "500px"));
    }

    addedGroup(event) {
        var groupId = event.data.groupId;
        this.setState({ groupId: groupId }, this.getGroups);
    }

    changeGroupConfirm() {
        var drawerContent = <ChangeGroupConfirm changeTheGroup={this.changeTheGroup} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, "right", drawerContent, true, "500px"));
    }

    changeTheGroup() {
        const company = (this.state.companies || []).find(c => c.id == this.state.companyId)
        this.props.updateGroup(
            this.state.groupId,
            this.state.consentQuestionId,
            this.state.companyId,
            company ? company.name : undefined
        );
        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, "right", null, true));
    }

    render() {
        if (!this.state.isLoaded) return <div></div>

        var groupData = this.state.groupData.map(theRow => {
            return { label: theRow.groupName, value: Number(theRow.id) }
        });
        groupData.unshift({ label: "Select a Group", value: -1 });

        const companies = this.state.companies || [];
        const companyOptions = companies.map(c => ({
            label: c.name,
            value: Number(c.id),
        }));
        const selectedCompanyId = this.state.companyId != null && this.state.companyId !== ''
            ? Number(this.state.companyId)
            : companyOptions[0]
                ? companyOptions[0].value
                : -1;

        const consentOptions = [
            { label: 'All marketing yes/no questions (default)', value: 'all' },
            ...this.state.marketingQuestions.map(q => ({
                label: q.label || (`Question ${q.id}`),
                value: String(q.id),
            })),
        ];
        const selectedConsentQuestionId = this.state.consentQuestionId || 'all';
        if (selectedConsentQuestionId && selectedConsentQuestionId !== 'all' && !consentOptions.some(o => String(o.value) === selectedConsentQuestionId)) {
            consentOptions.push({
                label: `Question ${selectedConsentQuestionId} (saved)`,
                value: selectedConsentQuestionId,
            })
        }

        return <div>
            <Paper>
                <h4 className="mar-b25">Lets get started!</h4>
                {this.state.connectionError &&
                    <WarningHolder className="mar-b25" style={{ textAlign: 'left' }}>
                        <p className="mar-b10">{this.state.connectionError}</p>
                        {this.props.onReconnect &&
                            <Button className="button-sml red outline" text="Reconnect" onClick={this.props.onReconnect} />
                        }
                    </WarningHolder>
                }
                <p>Please select a group which will be synced with your Little Box Office customers</p>
                <Row margin={0}>
                    {groupData.length &&
                        <Column xs={12}>
                            <div className="quickFlex">
                                <div className="form-group mar-b0"><Select data={groupData} name="groupId" value={this.state.groupId} onChange={this.changeGroup} /></div>
                                <span style={{ marginLeft: "10px" }}>or</span>
                                <Button text="Add a new Group" className="button-sml outline secondary" style={{ marginLeft: "10px" }} onClick={this.addAGroup} />
                            </div>
                        </Column>
                    }
                    {companies.length > 1 &&
                        <Column xs={12} className="mar-t25">
                            <h4 className="mar-b10">LBO company</h4>
                            <p>Your API token has access to multiple Little Box Office companies. Choose which one to sync.</p>
                            <div className="form-group mar-b0" style={{ maxWidth: '400px' }}>
                                <Select
                                    data={companyOptions}
                                    name="companyId"
                                    value={selectedCompanyId}
                                    onChange={this.changeCompany}
                                />
                            </div>
                        </Column>
                    }
                    <Column xs={12} className="mar-t25">
                        <h4 className="mar-b10">Marketing consent</h4>
                        <p>Choose which Little Box Office marketing question is the point of truth for subscribe/unsubscribe status. By default, every marketing yes/no question is considered.</p>
                        <div className="form-group mar-b10" style={{ maxWidth: '500px' }}>
                            <Select
                                data={consentOptions}
                                name="consentQuestionId"
                                value={selectedConsentQuestionId}
                                onChange={this.changeConsent}
                            />
                        </div>
                        {!this.state.marketingQuestions.length &&
                            <p className="text-xsml">No marketing questions found yet. More options may appear after customers sync from Little Box Office.</p>
                        }
                        {this.state.marketingError &&
                            <p className="text-error">{this.state.marketingError}</p>
                        }
                    </Column>
                    <Column xs={12} margin={0}>
                        {this.state.groupId != -1 && <Button text="Continue" className="button-sml" onClick={this.changeGroupConfirm} />}
                    </Column>
                </Row>
            </Paper>
        </div>
    }
}
